<template>
  <div class="interaction-body display-maximum check-all-that-apply check-all-that-apply-display-maximum">
    <div
      class="checkbox-option playposit-answer mb-1 pa-1"
      :key="io.id"
      v-for="(io, idx) in localInteraction.interactionOptions"
    >
      <v-checkbox
        class="mt-0"
        v-model="io.correct"
        :ripple="false"
        readonly
        hide-details
        :color="io.correct ? '#4CAF50' : ''"
      >
        <div
          slot="label"
          class="pp-interaction-body full-width"
          v-html="io.option"
        ></div>
      </v-checkbox>
      <InteractionAttachments :attachments="io.interactionOptionAttachments" />
      <text-box
        v-show="!!io.feedback.length"
        color-key="feedback"
        title="Feedback"
        :text="io.feedback"
        :show-text="true"
        tabindex="0"
        :aria-label="`Feedback for answer #${idx + 1}: ${io.feedback.length ? io.feedback.stripHTML(['img', 'Image']) : ''}`"
        :attachments="io.interactionOptionFeedbackAttachments"
        :add-extra-space-above="!io.interactionOptionAttachments.length"
      ></text-box>
    </div>
    <v-layout
      v-if="typeof localInteraction.jumpCorrect === 'number'"
      class="caption muted mt-3"
      align-center
      justify-start
    >
      <v-icon small class="muted no-flex mr-1">call_split</v-icon>
      If correct, jumps to {{$convertTimestamp(localInteraction.jumpCorrect)}}.
    </v-layout>
    <v-layout
      v-if="typeof localInteraction.jumpIncorrect === 'number'"
      class="caption muted"
      :class="{
        'mt-3': typeof localInteraction.jumpCorrect !== 'number'
      }"
      align-center
      justify-start
    >
      <v-icon small class="muted no-flex mr-1">call_split</v-icon>
      If incorrect, jumps to {{$convertTimestamp(localInteraction.jumpIncorrect)}}.
    </v-layout>
  </div>
</template>

<script>
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'CheckAllThatApplyDisplayMaximumInteractionBody',
  components: {
    InteractionAttachments,
    TextBox,
  },
  mixins: [
    Interaction,
  ],
};
</script>